import React from 'react';

import { ColorModeSelector } from '@fragment/ui/src/components/ColorMode/ColorModeSelector';

import { useUserInfo } from '../../../../hooks/useUserInfo';

export const Profile = ({
  hideHeader = false,
}: { hideHeader?: boolean } = {}) => {
  const { data: userInfo } = useUserInfo();
  return (
    <div className="flex flex-col">
      {!hideHeader && <span>Profile</span>}
      <div className="flex flex-col mt-f4">
        <div className="flex items-center justify-center h-f2 w-f2 bg-main text-negative">
          {userInfo?.firstName?.[0]?.toUpperCase() || 'U'}
        </div>
        <div className="flex flex-col mt-f2">
          <span>
            {userInfo?.firstName} {userInfo?.lastName}
          </span>
          <span className="text-main-500">{userInfo?.email}</span>
          <span className="text-main-500">
            Member of {userInfo?.workspaces?.length} Workspaces
          </span>
        </div>
      </div>
    </div>
  );
};

export const Preferences = ({
  hideHeader = false,
}: { hideHeader?: boolean } = {}) => (
  <div>
    {!hideHeader && (
      <div className="pb-f4">
        <span className="text-main">Preferences</span>
      </div>
    )}
    <div className="space-y-f3">
      <div>
        <span className="text-main-500">Theme</span>
        <ColorModeSelector />
      </div>
    </div>
  </div>
);
